export enum GaugeColor {
  red = "red",
  yellow = "yellow",
  green = "green",
}
